import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";

const ToggleButtons = ({alignment, handleAlignment}) => {
	return (
		<Box>
			<ToggleButtonGroup
				value={alignment}
				exclusive
				onChange={handleAlignment}
				aria-label="text alignment"
			>
				<ToggleButton value="left" aria-label="left aligned">
					<FormatAlignLeftIcon/>
				</ToggleButton>
				<ToggleButton value="center" aria-label="centered">
					<FormatAlignCenterIcon/>
				</ToggleButton>
				<ToggleButton value="right" aria-label="right aligned">
					<FormatAlignRightIcon/>
				</ToggleButton>
				<ToggleButton value="justify" aria-label="justified" disabled>
					<FormatAlignJustifyIcon/>
				</ToggleButton>
			</ToggleButtonGroup>
		</Box>
	)
}

export default ToggleButtons;